import type { CuroOpsAccessUser } from "@/utils/curoOpsAccess";

/** Ani staff tenant (`company_id` === `ani`; email domain does not grant staff). */
export function isAniStaff(user: CuroOpsAccessUser | null | undefined): boolean {
  return (user?.company_id ?? "").toLowerCase() === "ani";
}

const ANI_INTERNAL_EMAIL_SUFFIX = "@ani.tech";

/** Ani company or internal @ani.tech staff (mirrors API ``is_ani_platform_staff``). */
export function isAniPlatformStaffUser(user: CuroOpsAccessUser | null | undefined): boolean {
  if (isAniStaff(user)) {
    return true;
  }
  return (user?.email ?? "").toLowerCase().endsWith(ANI_INTERNAL_EMAIL_SUFFIX);
}
